import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";

const InspectorTaller = (props) => {
  const cookie = new Cookies();
  const [talleres, setTalleres] = useState([]);
  const idUsuario = cookie.get("id"); // Obtener el idUsuario de las cookies
  const tallerSeleccionado = cookie.get("tallerSeleccionado"); // Obtener el taller seleccionado de las cookies

  useEffect(() => {
    const fetchTalleres = async () => {
      try {
        const response = await fetch(
          "https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerTalleres",
        );
        const data = await response.json();
        setTalleres(data);
      } catch (error) {
        console.error("Error fetching talleres:", error);
      }
    };

    fetchTalleres();
  }, []);

  const handleSelectTaller = () => {
    const options = [
      { value: "", text: "Seleccione el taller" },
      ...talleres.map((taller) => ({
        value: taller.id,
        text: taller.nombreTaller,
      })),
    ];

    Swal.fire({
      title: "Seleccione el Taller donde se encuentra ubicado",
      input: "select",
      inputOptions: options.reduce((obj, taller) => {
        obj[taller.value] = taller.text;
        return obj;
      }, {}),
      inputPlaceholder: "Seleccione el taller",
      inputValidator: (value) => {
        return new Promise((resolve) => {
          if (value == "") {
            resolve("Debe seleccionar un taller");
          } else {
            resolve();
          }
        });
      },
      showCancelButton: false,
      confirmButtonText: "Seleccionar",
      showLoaderOnConfirm: true,
      preConfirm: async (id) => {
        try {
          const taller = talleres.find((t) => t.id == id);
          if (!taller) {
            return Swal.showValidationMessage(`Taller no encontrado`);
          }
          return taller;
        } catch (error) {
          Swal.showValidationMessage(`Solicitud fallida: ${error}`);
        }
      },
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(
          `https://inspecciongnvback.azurewebsites.net/api/v1/InspectorTaller/${idUsuario}/${result.value.id}`,
          {
            method: "POST",
          },
        )
          .then((data) => {
            // Guardar el taller seleccionado en las cookies
            cookie.set("tallerSeleccionado", result.value.id, { path: "/" });
            Swal.fire({
              title: `Taller: ${result.value.nombreTaller}`,
              text: "Registro insertado con éxito",
            }).then(() => {
              window.location.reload("/");
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: `No se pudo insertar el registro: ${error.message}`,
            });
          });
      }
    });
  };

  useEffect(() => {
    if (talleres.length > 0 && !tallerSeleccionado) {
      handleSelectTaller();
    }
  }, [talleres, tallerSeleccionado]);

  return <></>;
};

export default InspectorTaller;
